import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=2f579a8c&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=ts"
export * from "./Tour.vue?vue&type=script&lang=ts"
import style0 from "./Tour.vue?vue&type=style&index=0&id=2f579a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f579a8c",
  null
  
)

export default component.exports